import { Component, Vue } from 'vue-property-decorator';
import RequestButtonBack from '@/components/request/RequestButtonBack/RequestButtonBack.vue';
import RequestDetail from '@/components/request/RequestDetail/RequestDetail.vue';

@Component<Request>({
  components: {
    'request-detail': RequestDetail,
    'request-button-back': RequestButtonBack,
  }
})
export default class Request extends Vue {
  protected mounted(): void {
    console.log(`Request Mounted with id: ${this.$route.params.id}`);
  }
}
